{
    "label": "Teamstruktur",
    "placeholder": "Der Editor für die Teamstruktur wird gerade gebaut."
}
